export default __webpack_public_path__ + "static/m-03-673c56faa798575d95bb39b9052e1ddc.jpeg";